<template>
  <div>
    <banners :banners="banners" :title="title" />
    <div class="landing-page">
      <div class="landing-page__container">
        <div class="landing-page__description" style="margin: 25px !important">
          <p
            class="landing-page__description-subtitle"
            v-html="$t('landing_pages.copo-life.first_description')"
          ></p>
        </div>
      </div>
      <div>
        <shelf :shelf-products="shelf" :use-cache="false" :first-shelf="true" />
      </div>
      <div class="landing-page__container">
        <div class="landing-page__description">
          <h2 class="landing-page__description-title">
            {{ $t('landing_pages.copo-life.second_title') }}
          </h2>
        </div>
        <div class="landing-page__gallery-container">
          <div class="landing-page__gallery-column">
            <video
              class="landing-page__gallery-main-video"
              src="/gocase_copo_life.mp4"
              controls
              autoplay
              muted
              loop
            ></video>
          </div>
          <div
            class="landing-page__gallery-column landing-page__gallery-secondary-column"
          >
            <img
              :src="firstHeroBanner"
              alt="Copo Life Principal"
              class="landing-page__gallery-secondary-image"
            />
            <img
              :src="secondHeroBanner"
              alt="Copo Life Principal"
              class="landing-page__gallery-secondary-image"
            />
          </div>
        </div>
      </div>
      <div class="landing-page__container">
        <div
          v-if="$isBrStore || isSubstore"
          style="display: flex; flex-direction: column; align-items: center"
        >
          <div class="landing-page__description">
            <h2 class="landing-page__description-title">
              {{ $t('landing_pages.copo-life.third_title') }}
            </h2>
          </div>

          <div class="landing-page__wrapper-container">
            <div class="landing-page__wrapper">
              <div class="landing-page__gallery">
                <a
                  v-for="(minibanner, index) in minibanners"
                  :key="index"
                  class="landing-page__gallery-item"
                  :href="minibanner.redirectLink"
                  rel="noopener"
                >
                  <img :src="minibanner.src" :alt="minibanner.alt" />
                </a>
              </div>
            </div>
          </div>

          <div class="landing-page__description">
            <h2 class="landing-page__description-title">
              {{ $t('landing_pages.copo-life.fourth_title') }}
            </h2>
          </div>

          <div class="landing-page__wrapper-container">
            <div class="landing-page__wrapper">
              <div class="landing-page__gallery">
                <div
                  v-for="(comparativeMinibanner,
                  index) in comparativeMinibanners"
                  :key="index"
                  class="landing-page__gallery-item"
                >
                  <a :href="comparativeMinibanner.redirectLink">
                    <img
                      :src="comparativeMinibanner.src"
                      :alt="comparativeMinibanner.alt"
                    />
                  </a>
                  <p class="landing-page__gallery-title">
                    {{ comparativeMinibanner.alt }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="landing-page-shelf__cta">
          <nuxt-link
            v-if="seeMore"
            class="landing-page-shelf__see-more"
            :to="seeMore"
          >
            <span class="landing-page-shelf__see-more__label">
              {{ $t('shelf.see_more') }}
              <span class="landing-page-shelf__see-more-arrow">&rarr;</span>
            </span>
          </nuxt-link>
        </div>

        <div class="landing-page__hero-banner">
          <img :src="nextToLastHeroBanner" alt="Copo Life" />
        </div>

        <div class="landing-page__hero-banner">
          <img :src="lastHeroBanner" alt="Copo Life" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Shelf from '~/components/pages/shelf/Shelf.vue'
import Banners from '~/components/pages/banners/Banners.vue'
export default {
  components: {
    Shelf,
    Banners,
  },
  data() {
    return {
      title: 'Copo Life',
      seeMore:
        '/copo-life/?product_filter=copo-life&page=1&sorting=favorites&new=1',
    }
  },
  computed: {
    storeInfo() {
      return this.$store.getters.storeInfo
    },
    shelf() {
      return {
        id: 6221,
        label: this.$t('landing_pages.copo-life.shelf_title'),
        see_more: this.$isBrStore
          ? 'https://www.gocase.com.br/copo-life/?product_filter=copo-life&page=1&sorting=favorites&new=1'
          : this.isSubstore
          ? '/copo-life/?product_filter=copo-life&page=1&sorting=favorites&new=1'
          : 'https://www.gocase.com.br/copo-life/?product_filter=copo-life&page=1&sorting=favorites&new=1',
        type: 'custom',
      }
    },
    isGlobalStore() {
      return !(
        this.$isBrStore || this.$store.getters.storeInfo?.substore === 'us'
      )
    },
    isSubstore() {
      return this.$store.getters.storeInfo?.substore === 'us'
    },
    banners() {
      const bannersBr = [
        {
          name: 'Copo Life',
          link_url:
            'https://www.gocase.com.br/copo-life/?product_filter=copo-life&page=1&sorting=favorites&new=1',
          desktop_image:
            'https://ik.imagekit.io/gocase/engines/qr-img/68641892213874991731930137269.png',
          mobile_image:
            'https://ik.imagekit.io/gocase/engines/qr-img/53494780403475721731930165078.png',
        },
      ]

      return bannersBr
    },
    firstHeroBanner() {
      const heroBannerBr =
        'https://ik.imagekit.io/gocase/engines/qr-img/118959579155855311731930568176.png'

      return heroBannerBr
    },
    secondHeroBanner() {
      const heroBannerBr =
        'https://ik.imagekit.io/gocase/engines/qr-img/03191316158172431731930699791.png'

      return heroBannerBr
    },
    minibanners() {
      const minibannersBr = [
        {
          src:
            'https://ik.imagekit.io/gocase/engines/qr-img/275218028211140051731931081863.png',
          alt: 'Rosa',
          redirectLink:
            'https://www.gocase.com.br/copo-life//?product_filter=copo-life&page=1&sorting=favorites&new=1&case_device=360lifepink-copolife1180ebook',
        },
        {
          src:
            'https://ik.imagekit.io/gocase/engines/qr-img/131096991116167241731930900507.png',
          alt: 'Preto',
          redirectLink:
            'https://www.gocase.com.br/copo-life//?product_filter=copo-life&page=1&sorting=favorites&new=1&case_device=360lifepreto-copolife1180ebook',
        },
        {
          src:
            'https://ik.imagekit.io/gocase/engines/qr-img/139045706314966161731930928691.png',
          alt: 'Off White',
          redirectLink:
            'https://www.gocase.com.br/copo-life//?product_filter=copo-life&page=1&sorting=favorites&new=1&case_device=360lifeoffwhite-copolife1180ebook',
        },
        {
          src:
            'https://ik.imagekit.io/gocase/engines/qr-img/56630614546520711731931125048.png',
          alt: 'Azul',
          redirectLink:
            'https://www.gocase.com.br/copo-life//?product_filter=copo-life&page=1&sorting=favorites&new=1&case_device=360lifeazulmarinho-copolife1180ebook',
        },
      ]

      return minibannersBr
    },
    comparativeMinibanners() {
      const comparativeMinibannersBr = [
        {
          src:
            'https://ik.imagekit.io/gocase/engines/qr-img/78254918797517841731931243317.png',
          alt: 'Mais Vendidas',
          redirectLink:
            'https://www.gocase.com.br/copo-life//?product_filter=copo-life&page=1&sorting=relevance&new=1',
        },
        {
          src:
            'https://ik.imagekit.io/gocase/engines/qr-img/91797831818035871731931279142.png',
          alt: 'Lançamentos',
          redirectLink:
            'https://www.gocase.com.br/copo-life//?product_filter=copo-life&page=1&sorting=newest&new=1',
        },
        {
          src:
            'https://ik.imagekit.io/gocase/engines/qr-img/51025147821769211731931307224.png',
          alt: 'Disney',
          redirectLink:
            'https://www.gocase.com.br/copo-life//?product_filter=copo-life&page=1&sorting=favorites&new=1&taxon=colecoes%2Fdisney',
        },
        {
          src:
            'https://ik.imagekit.io/gocase/engines/qr-img/123281504614114471731931331381.png',
          alt: 'Minimalistas',
          redirectLink:
            'https://www.gocase.com.br/copo-life//?product_filter=copo-life&page=1&sorting=favorites&new=1&taxon=themes%2Fminimalist',
        },
      ]

      return comparativeMinibannersBr
    },
    nextToLastHeroBanner() {
      const lastHeroBannerBr =
        'https://ik.imagekit.io/gocase/engines/qr-img/5855007744732651731931414653.jpeg'

      return lastHeroBannerBr
    },
    lastHeroBanner() {
      const lastHeroBannerBr =
        'https://ik.imagekit.io/gocase/engines/qr-img/420777696827738251731941280315.jpeg'

      return lastHeroBannerBr
    },
  },
  head() {
    return {
      title: this.title,
    }
  },
}
</script>

<style lang="scss" scoped>
.landing-page {
  background-color: #fcfdf7;
  position: relative;
  min-height: 399px;
  color: #000 !important;

  &__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  &__description {
    text-align: center;
    margin: 42px 15px;

    &-title {
      font-size: 36px;
      margin: 0px !important;
    }

    &-subtitle {
      font-size: 20px;
      font-weight: 300;
      margin: 5px 0 5px 0 !important;
      max-width: 800px;
    }
  }

  &__hero-banner {
    width: 100%;

    img {
      overflow-clip-margin: content-box;
      overflow: clip;
      width: 100%;
    }
  }
}

.landing-page__wrapper-container {
  position: relative;

  .landing-page__wrapper {
    overflow-x: auto;

    .landing-page__gallery {
      display: flex;
      flex-flow: row nowrap;
      gap: 15px;

      .landing-page__gallery-item {
        cursor: pointer;
        flex-shrink: 0;

        img {
          max-width: 500px;
          max-height: 500px;
          width: 100%;
        }
      }
    }
  }
}

img {
  overflow-clip-margin: content-box;
  overflow: clip;
}
.landing-page__wrapper::-webkit-scrollbar {
  display: none;
}

.landing-page__wrapper {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.landing-page__gallery-item:first-child {
  padding-left: 15px !important;
}

.landing-page__gallery-item:nth-last-child(1) {
  padding-right: 15px !important;
}

.landing-page-shelf__cta {
  margin: 60px 0px 40px 0px;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
  z-index: 1;
}

.landing-page-shelf__see-more {
  padding: 12px 18px 12px;
  font-size: 12px;
  text-transform: uppercase;
  border-radius: 4px;
  display: inline-block;
  text-decoration: none;
  background-color: $v4_color_primary;
  color: white;
  min-width: 200px;

  .landing-page-shelf__see-more-arrow {
    display: inline-block;
    transition: all 200ms ease-in-out;
  }

  &:hover {
    background-color: darken($v4_color_primary, 5%);

    .landing-page-shelf__see-more-arrow {
      transform: translateX(5px);
    }
  }
}

.landing-page__gallery-title {
  margin-top: 10px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}

.landing-page__gallery-container {
  display: flex;
  gap: 15px;
}

.landing-page__gallery-column {
  flex: 1;
  max-width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-content: space-between;
}

.landing-page__gallery-main-video {
  width: 100%;
  max-width: 90%;
  height: auto;
  border-radius: 5px;
  object-fit: contain;
  margin: 0;
  align-self: flex-end;
}

.landing-page__gallery-secondary-image {
  width: 100%;
  max-width: 90%;
  height: auto;
  border-radius: 5px;
  object-fit: contain;
  align-self: flex-start;

  &:last-child {
    margin-bottom: 0;
  }
}

@media (min-width: 768px) {
  .landing-page__gallery-column {
    &:first-child {
      flex: 2;
    }

    &.landing-page__gallery-secondary-column {
      flex: 1;
    }
  }

  .landing-page__gallery-main-video {
    height: 100%;
  }

  .landing-page__gallery-secondary-image {
    height: calc(50% - 10px);
  }
}

@media (min-width: 1110px) {
  .landing-page {
    &__description {
      text-align: center;
      margin: 42px 0px;

      &-title {
        font-size: 40px;
      }

      &-subtitle {
        font-size: 24px;
        font-weight: 300;
        margin: 5px 0 5px 0 !important;
        max-width: 800px;
      }
    }
  }
  .landing-page__container {
    width: 1170px;
    margin-right: auto;
    margin-left: auto;
  }

  .landing-page__wrapper-container {
    position: relative;
    margin: 0px;

    .landing-page__wrapper {
      .landing-page__gallery {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;

        .landing-page__gallery-item {
          cursor: pointer;
          flex-shrink: 1;

          img {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
